export const HOME_URL = import.meta.env.VITE_HOME_URL || '/';
